import React from 'react';
import { useParams } from 'react-router-dom';
import PdfToReactFormGenerator from './PdfToReactFormGenerator';

const FormDefinitionEditor: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return <PdfToReactFormGenerator mode="edit" definitionId={id} />;
};

export default FormDefinitionEditor;
